import { useLabelResolutionInputs } from "@src/hooks/useLabelResolutionInputs";
import { resolveLabelMode } from "@src/utils/page-labels-resolver";
import { useMemo } from "react";

/**
 * Resolves the current label voice ("patient" third-person vs "self" first-person)
 * using the same precedence as page-label resolution:
 *   1. FEATURE_LABEL flag off  → "patient"
 *   2. age (dob or ageRange)   → <18 "patient", >=18 "self"  (patient/self-booking role only)
 *   3. role                    → "patient" role → "self", navigator/referrer → "patient"
 *
 * @param options.age - Optional explicit age; takes priority over the derived DOB age.
 */
export function useLabelMode(options?: { age?: number }): "patient" | "self" {
  const { role, enabled, age } = useLabelResolutionInputs(options);

  return useMemo(() => resolveLabelMode(role, { enabled, age }), [role, enabled, age]);
}
